import { ReactElement, useEffect, useRef, useState } from "react";
import { PlusIcon, ImageIcon, Trash2, ImagePlusIcon, CheckCircle } from "lucide-react";
import { Mesh, MeshPhysicalMaterial, Texture, TextureLoader } from "three";
import { CanvasProvider } from "components/ThreeItems/CanvasProvider";
import { Scene } from "components/ThreeItems/Scene";
import { Button } from "components/Button/Button";
import { useLangContext } from "context/Lang";
import { useEditorContext } from "../editor-provider";
import { DialogModal } from "components/dialog-modal/dialog-modal";
import { AsyncProcess } from "services/AsyncProcess";
import { routes } from "routes";
import { useDispatch } from "react-redux";
import { setToast } from "storeRedux/slices/toast";
import { Loader } from "components/Loader/Loader";
import { BoxServerImage } from "components/BoxImage/BoxImage";
import { useLoader } from "@react-three/fiber";
import { Pagination } from "components/pagination";

export const Material = (): ReactElement => {
    const { gW } = useLangContext();
    const { selectMesh } = useEditorContext(); // نفترض وجود هذا السياق للتحكم في العنصر المحدد
    const [textureImage, setTextureImage] = useState<string | null>(null);
    const selectRef = useRef<Mesh>(null);
    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [materials, setMaterials] = useState<MaterialType[] | null>(null);
    const dispatch = useDispatch();

    const [page,setPage]= useState<number>(0);
    const [totalPage,setTotalPage]= useState<number>(0);





    const [openModel, setOpenModel] = useState<boolean>(false);



    const getMaterials = () => {
        setIsLoading(true)

        // console.log("oooo")
        AsyncProcess({
            type: "get",
            url: routes.api.materials,
            data:{
                params:{
                    page: page-1>-1?page-1:0 
                }
            },
            setError: () => {
                setIsLoading(false)

            },
            effectProcess: [(res) => {
                if (res?.success === false) {
                    dispatch(
                        setToast({
                            detail: gW(res?.message || "happen-error"),
                            severity: "error",
                        })
                    );
                    setIsLoading(false);
                } else {
                    setIsLoading(false);
                    if (res?.success === false) {
                        dispatch(setToast({ detail: gW(res?.message || "happen-error"), severity: "error" }));
                    } else {
                        setMaterials(res?.data?.content);
                        setTotalPage(res?.data?.page?.totalPages);
                    }
                    //res?.data as MaterialType[]
                }
            }]
        })
    }





    useEffect(() => {
        if (selectMesh?.userData?.imageUrl) {
            setTextureImage(selectMesh?.userData?.imageUrl)
        }
    }, [selectMesh])




    useEffect(() => {
        getMaterials()
    }, [page])

    // 1. معالجة رفع الصورة
    const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];

        if (!file) return;


        const formData = new FormData();

        formData.append("file", file);


        setIsUploading(true);
        AsyncProcess({
            type: "post",
            url: routes.api.uploadMaterial,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
            setError: (err) => {
                setIsUploading(false);
                dispatch(
                    setToast({
                        detail: gW(err?.error || "happen-error", err?.words),
                        severity: "error",
                    })
                );
            },
            effectProcess: [(res) => {
                setIsUploading(false);
                if (res?.success === false) {
                    dispatch(
                        setToast({
                            detail: gW(res?.message || "happen-error"),
                            severity: "error",
                        })
                    );
                } else {
                    getMaterials()

                }
            }]
        });

    };


    const handleSelectMaterial = (m: MaterialType) => {
        if (m.imageUrl) {
            setTextureImage(m.imageUrl);
            applyTexture(m);
            setOpenModel(false);
        }
    };
    // 2. تطبيق النسيج على المجسم المختار وعلى المعاينة (Preview)
    const applyTexture = (m?: MaterialType) => {
        const loader = new TextureLoader();



        const url = m?.imageUrl ? process.env.REACT_APP_API_URL + routes.api.images + "/" + m?.imageUrl : null;



        if (m?.imageUrl) {
            setTextureImage(m?.imageUrl);
        }


      
        // تحديث المجسم المختار في المشهد الرئيسي
        if (selectMesh) {

        

            const targetMesh = selectMesh as Mesh;
            
            if (targetMesh && targetMesh.material) {
                const material = targetMesh.material as MeshPhysicalMaterial;
                if (url) {
                    loader.load(url, (texture) => {
                        material.map = texture;
                        material.needsUpdate = true;
                    });
                    selectMesh.userData.materialId = m?.id;
                    selectMesh.userData.imageUrl = m?.imageUrl;

                } else {

                    material.map = null;
                    material.needsUpdate = true;
                    selectMesh.userData.materialId = null;
                    selectMesh.userData.imageUrl = null;
                }
            }
        }
    };

    const removeTexture = () => {
        setTextureImage(null);
        applyTexture();
    };

    const PreviewMesh = ({ imageUrl, selectRef }: { imageUrl: string, selectRef: any }) => {
        let texture = useLoader(TextureLoader, imageUrl);
        return (
            <mesh ref={selectRef} scale={[5, 5, 5]}>
                <sphereGeometry />
                <meshPhysicalMaterial
                    map={texture}
                    transparent
                    key={imageUrl || 'empty'}
                />
            </mesh>
        );
    };

    return (<>

        <div className="w-full bg-primary-800/10 rounded-2xl  flex flex-col p-4 gap-4 border border-primary-100/20 backdrop-blur-md">
            <h3 className="text-sm font-bold text-primary-700 flex items-center gap-2">
                <ImageIcon size={16} /> {gW("material-settings")}
            </h3>

            <div className="flex gap-4  items-center">
                <div className="w-[100px] relative h-[100px] rounded-xl overflow-hidden bg-primary-900 shadow-inner border border-white/10">
                    <CanvasProvider hiddenPlayButton={true} className=" absolute top-0 left-0 w-full h-full" showSky={false} planeShow={false}>
                        <Scene isActiveSelect={false}>
                            {textureImage ?
                                <PreviewMesh
                                    selectRef={selectRef}
                                    imageUrl={

                                        `${process.env.REACT_APP_API_URL}${routes.api.images}/${textureImage}`

                                    }
                                />

                                : <>
                                    <mesh ref={selectRef} scale={[5, 5, 5]}>
                                        <sphereGeometry />
                                        <meshPhysicalMaterial
                                            transparent
                                        />
                                    </mesh>
                                </>}
                        </Scene>
                    </CanvasProvider>
                </div>

                <div className="flex-1 ">


                    <Button
                        onClick={() => { setOpenModel(true) }}
                        variant="outline"
                    >
                        <ImagePlusIcon size={18} />
                        {gW("select-texture")}
                    </Button>

                    {textureImage && (
                        <Button
                            variant="ghost"
                            className="w-full justify-start gap-2 text-red-500 hover:bg-red-50"
                            onClick={removeTexture}
                        >
                            <Trash2 size={18} />
                            {gW("remove-texture")}
                        </Button>
                    )}

                </div>
            </div>

        </div>
        <DialogModal
            title={gW("select-texture")}
            size="2xl"
            actions={[
                <div className=" flex items-center gap-2    " >
                    <Pagination
                        page={page}
                        totalPages={totalPage}
                        onChange={(e)=>{setPage(e)}}
                    />
                    <input
                        type="file"
                        ref={fileInputRef}
                        className="hidden"
                        accept="image/*"
                        onChange={handleImageUpload}
                    />
                    <Button onClick={() => fileInputRef.current?.click()} variant="outline" >
                        <PlusIcon />
                        {gW("new")}
                    </Button>
                </div>,
                
            ]}
            isOpen={openModel}
            onClose={() => setOpenModel(false)}

        >
            <div className="  ">
                {isLoading ? (
                    <Loader />
                ) : (<>
                
                    <div className=" grid grid-cols-2  lg:grid-cols-5 " >
                        {materials?.map((m) => (
                            <div
                                key={m.id}
                                onClick={() => handleSelectMaterial(m)}
                                className="relative aspect-square rounded-xl overflow-hidden border-2 border-transparent hover:border-primary cursor-pointer group shadow-sm"
                            >
                                <BoxServerImage
                                    src={m.imageUrl || undefined}
                                />
                                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                    <CheckCircle className="text-white" />
                                </div>
                                {/* <div className="absolute bottom-0 w-full bg-black/60 p-1">
                                    <p className="text-[8px] text-white text-center truncate">{m?.name}</p>
                                </div> */}
                            </div>
                        ))}
                        
                    </div>
                   
                </>
                )}


            </div>

        </DialogModal>
    </>
    );
}